/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_To_DashboardInputs */

const en_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Dashboard`)
};

const es_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al Panel`)
};

const fr_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au Tableau de bord`)
};

const de_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Dashboard`)
};

const ja_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダッシュボードへ`)
};

const zh_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往仪表板`)
};

const ar_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الذهاب إلى لوحة التحكم`)
};

const id_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka Dasbor`)
};

const it_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alla Dashboard`)
};

const ru_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти в Панель управления`)
};

const pt_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o Painel`)
};

const ko_go_to_dashboard = /** @type {(inputs: Go_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대시보드로 이동`)
};

/**
* | output |
* | --- |
* | "Go to Dashboard" |
*
* @param {Go_To_DashboardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const go_to_dashboard = /** @type {((inputs?: Go_To_DashboardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_To_DashboardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_go_to_dashboard(inputs)
	if (locale === "es") return es_go_to_dashboard(inputs)
	if (locale === "fr") return fr_go_to_dashboard(inputs)
	if (locale === "de") return de_go_to_dashboard(inputs)
	if (locale === "ja") return ja_go_to_dashboard(inputs)
	if (locale === "zh") return zh_go_to_dashboard(inputs)
	if (locale === "ar") return ar_go_to_dashboard(inputs)
	if (locale === "id") return id_go_to_dashboard(inputs)
	if (locale === "it") return it_go_to_dashboard(inputs)
	if (locale === "ru") return ru_go_to_dashboard(inputs)
	if (locale === "pt") return pt_go_to_dashboard(inputs)
	return ko_go_to_dashboard(inputs)
});